import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { PushNotificationItemDto } from '../../data-models/notification.data.models';

@Injectable({
  providedIn: 'root'
})
export class NotificationDataService {
    private controllerUrl: string = `Notifications/`;
  
    constructor(
      private baseApi: BaseApiService<any>,
    ) { }

    GetNotificationsList(pageIndex: number,pageSize:number): Observable<any> {
      return this.baseApi.Get(`${this.controllerUrl}GetNotificationsList?pageIndex=${pageIndex}&pageSize=${pageSize} `);
    }
    GetNofiticationDetails(notificationId: string): Observable<any> {
      return this.baseApi.Get(`${this.controllerUrl}GetNofiticationDetails?notificationId=${notificationId} `);
    }
    GetUnreadNotificationsCount(): Observable<any> {
      return this.baseApi.Get(`${this.controllerUrl}GetUnreadNotificationsCount`);
    }

  }